import { l as _inherits, a as _createClass, h as _extends, b as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-f5c57928.js';
import PropTypes, { imageShape } from 'prop-types';
import * as React from 'react';
import React__default from 'react';
import Slider from 'react-slick';
import Image from './Image.js';
import Label from './Label.js';
import { d as defaultImage } from './general-2a8d8650.js';
import { b as __spreadArray, a as __rest } from './tslib.es6-2748fcb6.js';
import { u as useIntl } from './useIntl-2030d1c8.js';
import { s as shallowEqual } from './injectIntl-0da7053c.js';
import './PropTypes-9aad034b.js';
import 'moment';
import './Modal.js';
import 'react-dom';
import './ModalHeader-daaa2bf6.js';
import './Icon.js';
import './_commonjsHelpers-97e6d7b1.js';
import './Title.js';
import './hoist-non-react-statics.cjs-596f6afc.js';
import './index-c093c499.js';

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = __rest(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = __rest(nextProps, ["values"]);
    return (shallowEqual(nextValues, values) &&
        shallowEqual(otherProps, nextOtherProps));
}
var FormattedMessage = React.memo(function (props) {
    var intl = useIntl();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? React.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (!Array.isArray(nodes)) {
        nodes = [nodes];
    }
    if (typeof children === 'function') {
        return children(nodes);
    }
    if (Component) {
        // Needs to use `createElement()` instead of JSX, otherwise React will
        // warn about a missing `key` prop with rich-text message formatting.
        return React.createElement.apply(React, __spreadArray([Component, null], nodes));
    }
    return React.createElement(React.Fragment, null, nodes);
}, areEqual);
FormattedMessage.displayName = 'FormattedMessage';

var PhotoGallery = /*#__PURE__*/function (_React$Component) {
  function PhotoGallery(props) {
    var _this;
    _classCallCheck(this, PhotoGallery);
    _this = _callSuper(this, PhotoGallery, [props]);
    _this.state = {
      photos: null,
      thumbnails: null
    };
    _this.positionThumbnails = 1;
    _this.initializedPhotos = false;
    _this.initializedThumbnails = false;
    _this.setPhotos = _this.setPhotos.bind(_this);
    _this.setThumbnails = _this.setThumbnails.bind(_this);
    _this.handleImageError = _this.handleImageError.bind(_this);
    return _this;
  }
  _inherits(PhotoGallery, _React$Component);
  return _createClass(PhotoGallery, [{
    key: "setPhotos",
    value: function setPhotos(photos) {
      if (!this.initializedPhotos) {
        this.setState({
          photos: photos
        });
        this.initializedPhotos = true;
      }
    }
  }, {
    key: "setThumbnails",
    value: function setThumbnails(thumbnails) {
      if (!this.initializedThumbnails) {
        this.setState({
          thumbnails: thumbnails
        });
        this.initializedThumbnails = true;
      }
    }
  }, {
    key: "handleImageError",
    value: function handleImageError(imageElement) {
      imageElement.target.src = defaultImage;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        images = _this$props.images,
        marketing = _this$props.marketing,
        thumbsEnabled = _this$props.thumbsEnabled,
        slidesToShow = _this$props.slidesToShow,
        intl = _this$props.intl,
        photoKeyPrefix = _this$props.photoKeyPrefix,
        thumbKeyPrefix = _this$props.thumbKeyPrefix,
        adaptiveHeight = _this$props.adaptiveHeight,
        hasUncroppedImages = _this$props.hasUncroppedImages;
      var _this$state = this.state,
        thumbnails = _this$state.thumbnails,
        photos = _this$state.photos;
      var GalleryThumbnails = thumbsEnabled ? thumbnails : false;
      var removeCloneThumbs = "gallery-thumbnails-wrapper ".concat(images.length < slidesToShow ? 'remove-clone-thumbs' : '');
      var imageMarketing = null;
      if (marketing) {
        if (marketing.mealPlan) {
          imageMarketing = {
            color: 'orange',
            content: marketing.mealPlan,
            ribbonLeft: true
          };
          return;
        }
        if (marketing.promotion) {
          imageMarketing = {
            color: 'yellow',
            content: /*#__PURE__*/React__default.createElement(FormattedMessage, {
              id: "bf.sale",
              defaultMessage: "bf.sale"
            }),
            ribbonLeft: true
          };
        }
      }
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, imageMarketing ? /*#__PURE__*/React__default.createElement(Label, _extends({
        className: "gallery-ribbon"
      }, imageMarketing)) : null, /*#__PURE__*/React__default.createElement(Slider, {
        asNavFor: GalleryThumbnails,
        adaptiveHeight: adaptiveHeight,
        ref: this.setPhotos,
        key: "ROOMS_DETAILS_GALLERY",
        className: "gallery-active-image-wrapper",
        lazyLoad: "progressive",
        fade: true,
        infinite: true
      }, images ? images.map(function (image, index) {
        var keyName = "".concat(photoKeyPrefix).concat(index);
        var altText = image.description || intl.formatMessage({
          id: 'bf.imagePreview',
          defaultMessage: 'bf.imagePreview'
        });
        return (
          /*#__PURE__*/
          // TODO @Milo (48536 - EU images) - in the rendered html, same url and alt text is displayed
          // but image itslef is changed...
          React__default.createElement(Image, {
            key: keyName,
            mainImage: {
              title: keyName,
              url: image.url ? image.url : defaultImage
            },
            onError: _this2.handleImageError,
            fluid: true,
            className: hasUncroppedImages ? 'has-not-cropped-image' : '',
            alt: altText
          })
        );
      }) : null), thumbsEnabled && images.length > 1 ? /*#__PURE__*/React__default.createElement(Slider, {
        key: "ROOMS_DETAILS_GALLERY_THUMBS",
        asNavFor: photos,
        ref: this.setThumbnails,
        slidesToShow: images.length > 3 ? 3 : images.length,
        slidesToScroll: this.positionThumbnails,
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        infinite: true,
        className: removeCloneThumbs
      }, images ? images.map(function (image, index) {
        var keyName = "".concat(thumbKeyPrefix).concat(index);
        var altText = image.description || intl.formatMessage({
          id: 'bf.displayImagePreview',
          defaultMessage: 'bf.displayImagePreview'
        });
        return /*#__PURE__*/React__default.createElement(Image, {
          key: keyName,
          mainImage: {
            title: keyName,
            url: image.url ? image.url : defaultImage
          },
          onError: _this2.handleImageError,
          fluid: true,
          className: hasUncroppedImages ? 'has-not-cropped-image' : '',
          alt: altText
        });
      }) : null) : null);
    }
  }]);
}(React__default.Component);
PhotoGallery.defaultProps = {
  images: [{
    url: defaultImage
  }],
  thumbsEnabled: false,
  slidesToShow: 5,
  photoKeyPrefix: 'PHOTO_',
  thumbKeyPrefix: 'THUMB_',
  adaptiveHeight: false,
  marketing: null,
  hasUncroppedImages: false
};
PhotoGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape(imageShape)),
  thumbsEnabled: PropTypes.bool,
  slidesToShow: PropTypes.number,
  photoKeyPrefix: PropTypes.string,
  thumbKeyPrefix: PropTypes.string,
  adaptiveHeight: PropTypes.bool,
  marketing: PropTypes.shape({
    mealPlan: PropTypes.string,
    promotion: PropTypes.string
  }),
  hasUncroppedImages: PropTypes.bool,
  intl: PropTypes.object.isRequired
};

export default PhotoGallery;
